import { render, staticRenderFns } from "./AS_Home.vue?vue&type=template&id=1456045b&"
import script from "./AS_Home.vue?vue&type=script&lang=js&"
export * from "./AS_Home.vue?vue&type=script&lang=js&"
import style0 from "./AS_Home.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports